<div
  class="ag-status-name-value ag-status-panel ag-status-panel-selected-row-count count-style"
>
  <span class="ag-status-name-value-value">{{ selectedCount }}</span>
  &nbsp;<span i18n="@@SelectedOrderCount">Selected</span>
</div>
